<!-- 就餐规则配置 -->
<template>
	<w-dialog ref="dialogRef" class="vip-dialog" title="就餐规则配置" width="55%" btnWidth="140px" top="3vh"
		confirmText="确认设置" @wConfirm="handleSure"  :hideFooter="authData.indexOf('n_14x81yb8y2eqk3hekwhgkmdfqec5') == -1">
		<el-form class="dining-records-form" ref="formRef" :model="formData" labelPosition="top">
			<el-card class="box-card">
				<template #header>
					<div class="card-header">
						<span>业主就餐配置</span>
					</div>
				</template>
				<div
					class="el-table--fit el-table--striped el-table--scrollable-y el-table--enable-row-transition el-table">
					<div class="el-table__header-wrapper">
						<table border="0" cellpadding="0" cellspacing="0" class="el-table__header">
							<colgroup>
								<col width="170">
								<col width="170">
								<col width="170">
								<col>
							</colgroup>
							<thead class="has-gutter">
								<tr>
									<th class="el-table__cell">
										<div class="cell">开始时间</div>
									</th>
									<th class="el-table__cell">
										<div class="cell">结束时间</div>
									</th>
									<th class="el-table__cell">
										<div class="cell">就餐费用（元）</div>
									</th>
									<th class="el-table__cell">
										<div class="cell">就餐规则说明</div>
									</th>
								</tr>
							</thead>
						</table>
						<table class="el-table__body" cellspacing="0" cellpadding="0" border="0">
							<colgroup>
								<col width="170">
								<col width="170">
								<col width="170">
								<col>
							</colgroup>
							<tbody>
								<tr class="el-table__row" v-for="(ov, oi) in formData.owner_dining_rule.rules"
									:key="oi">
									<td class="el-table__cell">
										<el-form-item :prop="`owner_dining_rule.rules.${oi}.stime`"
											:rules="[{ required: true, message: '开始时间不能为空', trigger: 'blur' }]">
											<el-time-select v-model="ov.stime" start="00:00" step="00:10" end="23:59"
												:max-time="ov.etime" format="HHmm" :clearable="false"
												:disabled="!(authData.indexOf('n_14x81yb8y2eqk3hekwhgkmdfqec5') != -1 && authData.indexOf('n_8nhl81kw8kbdu99kity4s9rm6vhe') != -1)" />
										</el-form-item>
									</td>
									<td class="el-table__cell">
										<el-form-item :prop="`owner_dining_rule.rules.${oi}.etime`"
											:rules="[{ required: true, message: '结束时间不能为空', trigger: 'blur' }]">
											<el-time-select v-model="ov.etime" start="00:00" step="00:10" end="23:59"
												:min-time="ov.stime" format="HHmm" :clearable="false"
												:disabled="!(authData.indexOf('n_14x81yb8y2eqk3hekwhgkmdfqec5') != -1 && authData.indexOf('n_8nhl81kw8kbdu99kity4s9rm6vhe') != -1)" />
										</el-form-item>
									</td>
									<td class="el-table__cell">
										<el-form-item :prop="`owner_dining_rule.rules.${oi}.price`" :rules="[
											{ required: true, message: '价格不能为空', trigger: 'blur' },
											{
												validator: (rule, value, callback) => {
													if (value === '' || value === null || value === undefined) {
														callback(new Error('价格不能为空'));
													} else if (isNaN(Number(value)) || Number(value) <= 0) {
														callback(new Error('价格必须为大于0的数字'));
													} else {
														callback();
													}
												}, trigger: 'blur'
											}
										]">
											<el-input v-model="ov.price" type="number"
												:disabled="authData.indexOf('n_14x81yb8y2eqk3hekwhgkmdfqec5') == -1" />
										</el-form-item>
									</td>
									<td class="el-table__cell">
										<el-form-item :prop="`owner_dining_rule.rules.${oi}.remark`"
											:rules="[{ required: true, message: '就餐规则说明不能为空', trigger: 'blur' }]">
											<el-input v-model="ov.remark" placeholder="Please input"
												:disabled="authData.indexOf('n_14x81yb8y2eqk3hekwhgkmdfqec5') == -1" />
										</el-form-item>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</el-card>
			<el-card class="box-card vip-dining-rule">
				<template #header>
					<div class="card-header">
						<span>普通会员就餐配置</span>
						<span class="vip-dining-swicth">
							普通会员就餐服务：
							<el-switch v-model="formData.owner_dining_rule.is_allow_not_owner" inline-prompt
								active-value="1" active-text="开" inactive-value="2" inactive-text="关" :disabled="authData.indexOf('n_14x81yb8y2eqk3hekwhgkmdfqec5') == -1" />
						</span>
					</div>
				</template>
				<div
					class="el-table--fit el-table--striped el-table--scrollable-y el-table--enable-row-transition el-table">
					<div class="el-table__header-wrapper">
						<table border="0" cellpadding="0" cellspacing="0" class="el-table__header">
							<colgroup>
								<col width="170">
								<col width="170">
								<col width="170">
								<col>
							</colgroup>
							<thead class="has-gutter">
								<tr>
									<th class="el-table__cell">
										<div class="cell">开始时间</div>
									</th>
									<th class="el-table__cell">
										<div class="cell">结束时间</div>
									</th>
									<th class="el-table__cell">
										<div class="cell">就餐费用（元）</div>
									</th>
									<th class="el-table__cell">
										<div class="cell">就餐规则说明</div>
									</th>
								</tr>
							</thead>
						</table>
						<table class="el-table__body" cellspacing="0" cellpadding="0" border="0">
							<colgroup>
								<col width="170">
								<col width="170">
								<col width="170">
								<col>
							</colgroup>
							<tbody>
								<tr class="el-table__row" v-for="(sv, si) in formData.outside_dining_rule.rules"
									:key="si">
									<td class="el-table__cell">
										<el-form-item :prop="`outside_dining_rule.rules.${si}.stime`"
											:rules="[{ required: true, message: '开始时间不能为空', trigger: 'blur' }]">
											<el-time-select v-model="sv.stime" start="00:00" step="00:10" end="23:59"
												format="HHmm" :clearable="false"
												:disabled="!(authData.indexOf('n_14x81yb8y2eqk3hekwhgkmdfqec5') != -1 && authData.indexOf('n_8nhl81kw8kbdu99kity4s9rm6vhe') != -1)" />
										</el-form-item>
									</td>
									<td class="el-table__cell">
										<el-form-item :prop="`outside_dining_rule.rules.${si}.etime`"
											:rules="[{ required: true, message: '结束时间不能为空', trigger: 'blur' }]">
											<el-time-select v-model="sv.etime" start="00:00" step="00:10" end="23:59"
												format="HHmm" :clearable="false"
												:disabled="!(authData.indexOf('n_14x81yb8y2eqk3hekwhgkmdfqec5') != -1 && authData.indexOf('n_8nhl81kw8kbdu99kity4s9rm6vhe') != -1)" />
										</el-form-item>
									</td>
									<td class="el-table__cell">
										<el-form-item :prop="`outside_dining_rule.rules.${si}.price`" :rules="[
											{ required: true, message: '价格不能为空', trigger: 'blur' },
											{
												validator: (rule, value, callback) => {
													if (value === '' || value === null || value === undefined) {
														callback(new Error('价格不能为空'));
													} else if (isNaN(Number(value)) || Number(value) <= 0) {
														callback(new Error('价格必须为大于0的数字'));
													} else {
														callback();
													}
												}, trigger: 'blur'
											}
										]">
											<el-input v-model="sv.price" type="number"
												:disabled="authData.indexOf('n_14x81yb8y2eqk3hekwhgkmdfqec5') == -1" />
										</el-form-item>
									</td>
									<td class="el-table__cell">
										<el-form-item :prop="`outside_dining_rule.rules.${si}.remark`"
											:rules="[{ required: true, message: '就餐规则说明不能为空', trigger: 'blur' }]">
											<el-input v-model="sv.remark" placeholder="Please input"
												:disabled="authData.indexOf('n_14x81yb8y2eqk3hekwhgkmdfqec5') == -1" />
										</el-form-item>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</el-card>
		</el-form>
	</w-dialog>
</template>

<script>
import { ref, computed, watch } from "vue";
import { StoreApi } from "@/plugins/api.js";
import { ElMessage } from "element-plus";
import { useStore } from "vuex";

export default {
	emits: ["submit"],
	components: {},
	setup() {
		// 弹框对象
		const dialogRef = ref(null);
		// 表单引用
		const formRef = ref(null);
		// 表单数据
		const formData = ref({
			owner_dining_rule: {
				rules: [],
				is_allow_not_owner: "1"
			},
			outside_dining_rule: {
				rules: []
			}
		});
		// 权限
		const authData = ref([]);
		const store = useStore();
		const menuTokens = computed(() => store.state.menuToken.menuTokens);
		// 监听权限
		watch(() => menuTokens.value,
			(data) => {
				if (data.length) {
					authData.value = data;
				}
			},
			{
				deep: true,
				immediate: true,
			}
		);

		/**
		 * 显示弹框
		 */
		function openDialog(row) {
			// 获取就餐配置
			StoreApi.getRecordConfigSearch({}).then((res) => {
				if (res.Code === 200) {
					formData.value = res.Data;
					dialogRef.value.show();
				} else {
					ElMessage.error(res.Message);
				}
			});
		}


		/**
		 * 确认提交
		 */
		function handleSure() {
			formRef.value.validate((valid) => {
				if (valid) {
					// 打开按钮加载状态
					dialogRef.value.isLoading = true;

					// 校验通过，执行后续提交逻辑
					StoreApi.setRecordConfig(formData.value).then(res => {
						// 打开按钮加载状态
						dialogRef.value.isLoading = false;

						if (res.Code === 200) {
							ElMessage.success(res.Message);
							dialogRef.value.close();
						} else {
							ElMessage.error(res.Message);
						}
					});
				} else {
					ElMessage.error('请检查表单填写内容');
				}
			});
		}

		return {
			authData,
			dialogRef,
			formRef,
			formData,
			openDialog,
			handleSure
		};
	},
};
</script>

<style lang="scss">
.dining-records-form {
	.el-card {
		--el-card-padding: 15px;
	}

	.el-card__body {
		padding: 0 10px;

		.el-table__footer-wrapper tbody td.el-table__cell,
		.el-table__header-wrapper tbody td.el-table__cell {
			background: none;
			padding: 10px;

			.el-form-item {
				margin-bottom: 15px;
			}

			.el-input__inner {
				background: none;
				border: var(--el-input-border, var(--el-border-base));
				font-weight: 400;
			}
		}
	}

	.vip-dining-rule {
		margin-top: 5px;

		.vip-dining-swicth {
			float: right;
		}
	}

}
</style>